// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"dae0e5ec","container":"f24a00f6"};